/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { ChevronDown } from '@carbon/react/icons';
import { useTranslation } from '../../../../Utilities/i18n/i18n.js';

/**
 * `ListBoxMenuIcon` is used to orient the icon up or down depending on the
 * state of the menu for a given `ListBox`
 */
var DropdownIcon = function DropdownIcon(_ref) {
  var isOpen = _ref.isOpen,
    overrideTranslations = _ref.overrideTranslations;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var className = classnames({
    'cds--list-box__menu-icon': true,
    'cds--list-box__menu-icon--open': isOpen
  });
  var description = isOpen ? (overrideTranslations === null || overrideTranslations === void 0 ? void 0 : overrideTranslations('close.menu')) || t('Close menu') : (overrideTranslations === null || overrideTranslations === void 0 ? void 0 : overrideTranslations('open.menu')) || t('Open menu');
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(ChevronDown, {
    name: "chevron--down",
    "aria-label": description
  }, /*#__PURE__*/React.createElement("title", null, description)));
};
DropdownIcon.propTypes = {
  /**
   * Specify whether the menu is currently open, which will influence the
   * direction of the menu icon
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * i18n hook used to provide the appropriate description for the given menu
   * icon. This function takes in an id and should
   * return a string message for that given message id.
   */
  overrideTranslations: PropTypes.func
};
DropdownIcon.defaultProps = {
  overrideTranslations: undefined
};
var DropdownIcon$1 = DropdownIcon;

export { DropdownIcon$1 as default };
